import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
/**
 * Cart model class
 */

export class CartModel extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getCount = () => this.model?.headers?.['cart-count'] ?? 0;

    this.getDelivery = () => this.model?.headers?.['cart-delivery'] ?? 0;

    this.getOriginalTotal = () => this.model?.headers?.['cart-original-total'] ?? 0;

    this.getReal = () => this.model?.headers?.['cart-real'] ?? 0;

    this.getTotal = () => this.model?.headers?.['cart-total'] ?? 0;
  }

  /**
   * Create cart model
   *
   * @param {object} object
   *
   * @return {CartModel}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Get count
   *
   * @return {number}
   */


}